{
  "city-card": {
    "text": {
      "explore-top-salons": "Objevte nejlepší salony v"
    }
  }
}
